module.exports = __webpack_public_path__ + "img/chart_icon_selected_mobile.274b547d.svg";